import { css } from "lit";

export const styles = css`
  td:first-child {
    padding-right: 0;
  }

  .thumbnail {
    height: 64px;
    aspect-ratio: 2 / 1;
    border-radius: var(--sds-size-radius-600);
    overflow: hidden;
    background: var(--sds-color-background-default-secondary);
    transition: background-color 0.2s ease;
  }

  .thumbnail img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .thumbnail-placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--sds-color-icon-default-secondary);
    transition: color 0.2s ease;
  }

  .ended-dim {
    opacity: 0.5;
  }

  dropdown-menu {
    --dropdown-trigger-border-radius: var(--sds-size-radius-full);
  }

  /* Event tile (mobile) */
  .mobile-view {
    gap: 0;
  }

  .event-tile {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-400);
  }

  .event-tile-header {
    display: flex;
    gap: var(--sds-size-space-400);
    align-items: flex-start;
  }

  .event-tile-info {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-200);
    min-width: 0;
    flex: 1;
  }

  .event-tile-title {
    font-weight: var(--sds-typography-weight-medium);
    font-size: var(--sds-typography-body-size-medium);
    color: var(--sds-color-text-default-default);
    transition: color 0.2s ease;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .event-tile-header .thumbnail {
    height: 64px;
    flex-shrink: 0;
    border-radius: var(--sds-size-radius-600);
  }

  .event-tile-details {
    display: flex;
    align-items: center;
    gap: var(--sds-size-space-400);
    font-size: var(--sds-typography-body-size-small);
    color: var(--sds-color-text-default-secondary);
    transition: color 0.2s ease;
  }

  .event-tile-details span + span {
    border-left: var(--sds-size-stroke-border) solid var(--sds-color-border-default-default);
    padding-left: var(--sds-size-space-400);
    transition: border-color 0.2s ease;
  }

  .event-tile-actions {
    display: flex;
    align-items: center;
    gap: var(--sds-size-space-300);
  }

  .event-tile-actions wow-button[full-width] {
    flex: 1;
  }

  .col-thumbnail-url {
    width: 128px;
  }

  td.col-title {
    max-width: 200px;
  }

  td.col-title > * {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .col-status {
    width: 96px;
  }

  .col-scheduled-start-time {
    width: 110px;
  }

  .col-start-time {
    width: 60px;
  }

  .col-fee-cents {
    width: 60px;
  }

  .col-tickets-sold {
    width: 60px;
  }

  .col-revenue-cents {
    width: 60px;
  }

  .col-action {
    width: 140px;
  }

  .col-menu {
    width: 32px;
  }
`;
